import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: { marginBottom: 0 },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 12
  },
  searchInputContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    marginBottom: 20,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 0
    }
  },
  searchInput: {
    marginBottom: 12
  },
  facilitiesListContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
      justifyContent: 'center'
    }
  },
  button: {
    width: '100%',
    paddingTop: 20,
    paddingBottom: 20,
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    justifyContent: 'flex-end',
    position: 'sticky',
    bottom: 0
  },
  circularProgress: {
    marginLeft: 8,
    color: theme.palette.primary.main
  }
}))

export default useStyles
